export default "__VITE_ASSET__BD6Eqwrz__"